module.exports = __webpack_public_path__ + "media/team_photos/Alexander-Pensenstadler-photo-ada71cf0.webp";